import _extends from "@babel/runtime/helpers/extends";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  border: 1px solid #cccfcf;\n  width: 28px;\n  border-radius: 1px;\n  margin-top: 5px;\n  box-sizing: border-box;\n  &:not(:first-child) {\n    margin-left: 10px;\n  }\n  &:not(:last-child) {\n    margin-right: 10px;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  box-sizing: border-box;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  padding: 0;\n  font-size: 22px;\n  line-height: 26px;\n  font-weight: bold;\n  border: 0;\n  outline: 0;\n  letter-spacing: 34.5px;\n  background: transparent;\n  box-sizing: border-box;\n  margin-left: ", "px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: ", "px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from '../../utils/styling/styled-components';
var Container = styled.div(_templateObject(), function (props) {
  return props.maxLength * 50;
});
var StyledInput = styled.input(_templateObject2(), function (props) {
  return (props.maxLength > 1 ? props.maxLength * 2 : 0) + 35;
});
var PlacementContainer = styled.div(_templateObject3());
var InputSpace = styled.span(_templateObject4());

var VerificationInput = function VerificationInput(props) {
  var _props$size;

  return /*#__PURE__*/React.createElement(Container, {
    className: props === null || props === void 0 ? void 0 : props.className,
    maxLength: props.maxLength
  }, /*#__PURE__*/React.createElement(StyledInput, _extends({
    size: (_props$size = props.size) !== null && _props$size !== void 0 ? _props$size : props.maxLength
  }, props)), /*#__PURE__*/React.createElement(PlacementContainer, null, Array.from({
    length: props.maxLength
  }).map(function (__, index) {
    return /*#__PURE__*/React.createElement(InputSpace, {
      key: "".concat(props === null || props === void 0 ? void 0 : props.id, "-input-space-").concat(index)
    });
  })));
};

export { VerificationInput };